import wechatApi from "@/api/api-wechat";
import globConfig from "@/config/config";
import shareImgName from "@/assets/img/share.jpg";

/* params结构
//其中type字段 share表示分享 chooseImage表示图片相关 其他参考微信文档
// info应该和type相对应 然后注入的时候 自己判断type然后就一把梭操作
 {
    "type":"share",
    "info":{
        "title":"会员中心",
        "desc":"这是一个真香的分享",
        "link":"http://a.b.com/index.html",
        "imgUrl":"http://a.b.com/a.jpg"
    }
}
 其他待定 理论上应该能指定到类型最好 然后内部注入的时候判断类型 按需注入
*/

const wxJsSdk = {
    //registerEvent (params, isForce = false) {
    registerEvent(params) {
        let that = this;
        if (typeof wx === 'object') {
            //默认注入分享 这个title好像还取不到
            //let _pageTile = document.getElementsByTagName('title')[0].innerText;
            //外面先设置了title
            let _pageTile = document.title2;
            params = params || {
                "type": "share",
                "info": {
                    //"title": to.meta.title || '',
                    "title": _pageTile || '',
                    //"desc": to.meta.title + ' 页面分享',
                    "desc": '好友为您分享【' + _pageTile + '】',
                    "link": location.href,
                    //"link": location.href.split('#')[0].replace('http://localhost:8080', 'https://member.yposdev.azsoft.xin'), //防止#号
                    //"imgUrl": ""
                    "imgUrl": location.origin + shareImgName
                }
            };
            //这里判断wx.ready里面自己埋下的标记
            if (!wx.configState) {
                console.log(wx.configState, 'wx.configState 为false 需要进行注入config');
                //需要进行编码
                let _locationUrl = encodeURIComponent(location.href.split('#')[0]);
                wechatApi.getJsSdk(_locationUrl).then((res) => {
                    //console.log(res, 'res'); //return;
                    //注入微信配置
                    let wxConf = {
                        //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.appId, // 必填，公众号的唯一标识
                        //timestamp: res.timestamp, // 必填，生成签名的时间戳
                        timestamp: parseInt(res.timestamp), // 必填，生成签名的时间戳
                        nonceStr: res.nonceStr, // 必填，生成签名的随机串
                        signature: res.signature, // 必填，签名
                        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表
                            //jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表
                    };
                    wx.config(wxConf);
                    wx.ready(function() {
                        //做个标记 表示配置注入成功了
                        wx.configState = true;
                        //未排除的才进行设置
                        if (globConfig.wxSdkEliminatePath.indexOf(location.pathname) === -1) {
                            console.log('路径未排除需要，开始进行事件注册');
                            that._registerApiEvent(params);
                            return true;
                        }
                        console.log('路径被排除需要，不进行事件注册');
                    });
                });
            } else {
                console.log(wx.configState, 'wx.configState 为true 无需注入config');
                //开始事件注册 因为是无刷新  所以每次更换path都应该注册
                that._registerApiEvent(params);
                //可以注入 但是未注入过的类型和页面 才能操作
                //if(globConfig.wxSdkEliminatePath.indexOf(location.pathname) === -1 && ! wx['config' + params.type]) {
                /*if(globConfig.wxSdkEliminatePath.indexOf(location.pathname) === -1 && ! wx['config' + params.type + location.pathname]) {
                    console.log(wx['config' + params.type + location.pathname], 'wx["config' + params.type + location.pathname + '"] false 需要事件注册');
                    that._registerApiEvent(params);
                    return true;
                }
                if(isForce){
                    console.log(isForce, 'isForce 为true 开发者自定义强制 事件注册');
                    that._registerApiEvent(params);
                    return true;
                }*/
                //console.log('没有进行事件注册');
            }
        }
    },

    _registerApiEvent(params) {
        //哪一项已经注入过了
        //wx['config' + params.type] = true;
        wx['config' + params.type + location.pathname] = true;
        if (params.type === 'share') {
            console.log('分享类开始');
            //分享到QQ或微信(这是新版)
            typeof wx.updateAppMessageShareData === 'function' && wx.updateAppMessageShareData({
                title: params.info.title || '', // 分享标题
                desc: params.info.desc || '', // 分享描述
                link: params.info.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: params.info.imgUrl || '', // 分享图标
                success: function() {
                    // 设置成功
                }
            });

            //分享到朋友圈或QQ空间(这是新版)
            typeof wx.updateTimelineShareData === 'function' && wx.updateTimelineShareData({
                title: params.info.title || '', // 分享标题
                link: params.info.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: params.info.imgUrl || '', // 分享图标
                success: function() {
                    // 设置成功
                }
            });
            //以下为旧版
            //分享给朋友
            wx.onMenuShareAppMessage({
                title: params.info.title || '', // 分享标题
                desc: params.info.desc || '', // 分享描述
                //link: params.info.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                link: params.info.link || '', // 域名限制 所以这是做测试的
                imgUrl: params.info.imgUrl || '', // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function() {
                    // 用户点击了分享后执行的回调函数
                }
            });

            //分享到朋友圈
            wx.onMenuShareTimeline({
                title: params.info.title || '', // 分享标题
                //link: params.info.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                link: params.info.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: params.info.imgUrl || '', // 分享图标
                success: function() {
                    // 用户点击了分享后执行的回调函数
                },
            });


        } else if (params.type === 'openLocation') { //没错每个接口都自己一个一个判断

        }
    }
};

export default wxJsSdk;


// WEBPACK FOOTER //
// ./src/libs/wxJssdk.ac.js